import { render, staticRenderFns } from "./AssetEditor.vue?vue&type=template&id=fc1060b4&"
import script from "./AssetEditor.vue?vue&type=script&lang=js&"
export * from "./AssetEditor.vue?vue&type=script&lang=js&"
import style0 from "./AssetEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports